module.exports = __webpack_public_path__ + "static/media/wd_page_area01_img_en.83248d1b.png";